import { AxiosService } from './axios.service'

export class ClubService {
	static baseURL = 'clube'

	/**
	 * Get the plans data
	 */
	static getPlans() {
		return AxiosService.get(`${this.baseURL}/planos`).then(
			({ data }) => data.data
		)
	}

	/**
	 * Subscribes a client to a plan
	 * @param {int} planId
	 *
	 * @param {int} addressId
	 *
	 * @param {boolean} termsAndConditionsRead
	 *
	 * @param {string} deviceId
	 *
	 * @param {object} creditCard
	 * shape
	 * {
	 *  "holderName": "string",
	 *  "number": "string",
	 *  "expirationMonth": "string",
	 *  "expirationYear": "string",
	 *  "securityCode": "string",
	 * }
	 *
	 * @param {string} recurrenceType
	 * ["monthly", "Yearly"]
	 *
	 * @param {int} billingDay
	 */
	static subscribe(params) {
		return AxiosService.post(`${this.baseURL}/assinar`, params).then(
			({ data }) => data
		)
	}

	/**
	 *
	 * @param {string} cancelationReason
	 */
	static unsubscribe(cancelationReason) {
		return AxiosService.post(
			`${this.baseURL}/cancelar-assinatura`,
			cancelationReason
		).then(({ data }) => data)
	}

	/**
	 *
	 * @param {string} params
	 */
	static changePlan(params) {
		return AxiosService.post(`${this.baseURL}/alterar-plano`, params).then(
			({ data }) => data
		)
	}

	/**
	 *
	 * @returns {object} The billing data
	 */
	static getPendingBillingData() {
		return AxiosService.get(`${this.baseURL}/regularizar`).then(
			({ data }) => data
		)
	}

	/**
	 * Regularize pending payment
	 *
	 * @param {string} cardId
	 * Id of the creditCard
	 *
	 * @param {string} deviceId
	 * Antifraud
	 */
	static regularizePendingBilling(params) {
		return AxiosService.post(`${this.baseURL}/regularizar`, params).then(
			({ data }) => data
		)
	}
}
